const qcNotePT = {
    "view": {
        "message": {
            "releaseHasQCIssues": "O lançamento {{releaseName}} tem problemas de QC, por favor edite o lançamento para obter feedback detalhado de QC, faça as alterações necessárias e envie novamente!",
            "trackHasQCIssues": "A faixa {{trackName}} tem problemas de QC, por favor edite a faixa para obter feedback detalhado de QC, faça as alterações necessárias e envie novamente!"
        }
    }
};

export default qcNotePT;